module.exports = __webpack_public_path__ + "static/media/BrixSans-Light-Italic.67434482.eot";